import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { makeStyles } from "@mui/styles";
import { TextField } from '@mui/material';
import "dayjs/locale/pt-br";

const useStyles = makeStyles({
  textField: {
    width: '100%',
    maxWidth: '100%',
  },
})

function InputDate({
  fullWidth = false,
  label,
  value,
  onChange,
  disabled = false,
  style = {},
  maxDate = null,
  minDate = null
}) {
  const classes = useStyles()
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        className={classes.textField}
        fullWidth={fullWidth}
        disabled={disabled}
        label={label}
        value={value}
        onChange={onChange}
        inputFormat="DD/MM/YYYY"
        margin="dense"
        orientation="landscape"
        clearLabel="Limpar"
        clearable={true}
        cancelLabel="Cancelar"
        showTodayButton={true}
        todayLabel="Hoje"
        autoOk={true}
        InputLabelProps={{ shrink: true }}
        inputProps={{
          margin: "dense",
        }}
        inputVariant="outlined"
        invalidDateMessage=""
        style={{ ...style }}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" fullWidth />
        )}
        maxDate={maxDate}
        minDate={minDate}
      />
    </LocalizationProvider>
  );
}

export default InputDate;